<template>
    <div class="border-title title">
      <p class="title">쿠폰 상단 이미지 관리<span class="desc">발송되는 쿠폰에 사용할 상단 이미지를 등록·관리할 수 있습니다.</span></p>
    </div>
  <div class="contents-detail-wrap">
    <div class="coupon-image-box">
      <div class="tab-area v3">
        <ul class="tab-list">
          <template v-if="couponImgData.v3.items.length > 0">
            <li v-for="(item, idx) in couponImgData.v3.items" 
              :key="idx"
              class="tab-item" 
              :class="{ active: couponImgData.v3.activeIndex === idx }">
              <button class="tab-btn" @click ="handleTabClick('v3', idx)">
                  <span class="tab-text">{{ item.text }}</span>
              </button>
            </li>
        </template>
        <!-- <template v-else></template> -->
        </ul>
      </div>
    </div>
    <div class="tab-wrap">
      <!-- <div class="tab-pannel" v-if="couponImgData.v3.activeIndex === 0" > -->
      <div class="tab-pannel">
        <div class="coupon-list-wrap">
          <div class="coupon-list-box">
            <div class="title">
              <!-- <h4 class="font-bold">총 <span class="text-green">{{ props.totalNum }}</span>건</h4> -->
              <h4 class="font-bold">총 <span class="text-green">{{ thumbnails.length}}</span>건</h4>
              <!-- <span class="desc" v-if="couponImgData.v3.activeIndex === 1" >(최대 {{ props.maxNum }}건)</span> -->
              <span class="desc" v-if="couponImgData.v3.activeIndex === 1" >(MY 최대 50건)</span>
            </div>
            <div class="outline-box" :class="showInput === false ? 'hg528' : ''">
              <ul class="coupon-thumb-list">
                <template v-if="thumbnails.length > 0">
                  <li class="coupon-thumb" :class="{ 'active': item?.imgKey === selectedItemImgKey }" v-for="(item, index) in thumbnails" :key="index">
                    <button type="button" @click="selectThumbnail(item)">
                      <img :src="item?.src" :alt="`${item?.alt}`" />
                    </button>
                    <button type="button" :class="{ 'btn-close': btnClass }" :disabled="isDisabled" @click="showCouponRemoveConfirm('v3', item)"></button>
                  </li>
                </template>
                <!-- <template v-else></template> -->
              </ul>
            </div>
            <div class="form-box mt28">
              <div class="form-group">
                <ComPCUpload
                    :token-provider="`api/v1/private/coupon-top-image/upload-token`"
                    :uploaded="couponImage"
                    @change="onChangeCouponImage"                      
                    label="쿠폰 상단 이미지"
                    :showInput="showInput"
                    :hide-label="false"
                    inputClass="md" 
                    buttonClass="btn-outline md" 
                    :showButton="true" 
                    buttonText="파일찾기"
                    :chkAcceptType="['png','jpg']"
                    placeholder="파일은 png, jpg 형식의 500kb 이하"
                />
              </div>
            </div>
          </div>
          <div class="preview-box">
            <div class="title">
              <h4 class="font-bold">샘플 미리보기</h4>
            </div>
            <div class="preview-thumb">
              <div class="coupon-box">
                <div class="coupon-thumb">
                  <img v-if="currentPreview.src" :src="currentPreview.src" :alt="currentPreview.alt">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-gray inset40 mt40">
          <h4 class="title">쿠폰 상단 이미지 등록 안내</h4>
          <ul class="dot-list mt24">
            <li>MY 배너는 최대 50개까지 등록이 가능합니다.</li>
            <li>쿠폰 상단 이미지는 366px*160px에 최적화되어 있습니다.</li>
            <li>파일은 png, jpg 형식의 500kb 이하 파일만 가능합니다.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import ComPCUpload from '@/components/com/HconComPCUpload.vue'

import { MEMBER_CODE, COMMON_CODE } from "@/constants/hconMessageConstants";
import { ref, reactive, type Ref } from 'vue';
import { usePopup } from '@/composables/hconUsePopup'

const { showAlert, showConfirm } = usePopup()

interface ConnerImageProps {
    showInput?: boolean
  , showBtnClose?: boolean
  , selectedTabIdx?: string
  , selectedTopImg?: string
}

const props = withDefaults(defineProps<ConnerImageProps>(), { showInput: true, showBtnClose: true, selectedTabIdx: '', selectedTopImg: '' });
const emit = defineEmits<{(e: 'select-item', id: number | string, tabIdx: string): void}>()

const couponImgData = ref({
  v3: {
    items: [] as Array<{text: string, tapMenuCd: string, rcntImgUseYn: string}>,
    activeIndex: 0
  }
})

//탭 유형 
type TabVersion = 'v3';
let tapMenuCd = '1001'
const isInitPage = ref(false)
const isDisabled = ref(false)
const btnClass = ref(false)

// 탭 클릭 핸들러
const handleTabClick = (version: TabVersion, index: number) => {
  couponImgData.value[version].activeIndex = index;
  tapMenuCd = String(couponImgData.value[version].items[index].tapMenuCd)
  getImageList(tapMenuCd)
};

const couponImage = ref<CommonFile[]>();
const onChangeCouponImage = (uploadedFiles: CommonFile[]) => {
  
  couponImage.value = uploadedFiles;
  const chkStatus = uploadedFiles.filter(file => file.status === 'STORED') // status 값 체크
  
  // temp 정상인 경우 Upload
  if(chkStatus.length > 0) {
    uploadImage()
  }
}

interface Thumbnails {
  id: number,
  src: string,
  alt: string,
  bigSrc: string, 
  fileId: string,
  imgKey: string
  useSeq?: string
}

interface CurrentPreview {
  src: string,
  alt: string
}

// 쿠폰 이미지 데이터
const thumbnails = reactive<Partial<Thumbnails[]>>([])

// preview image
const selectedItemId: Ref<number | null> = ref(null)
const selectedItemImgKey: Ref<string | null> = ref(null)
const currentPreview = ref<Partial<CurrentPreview>>({})

const selectThumbnail = (item: any) => {
  currentPreview.value.src = item.bigSrc || item.src
  currentPreview.value.alt = item.alt

  selectedItemId.value = item.id
  selectedItemImgKey.value = item.imgKey
  emit('select-item', item.id, tapMenuCd);
}

const showCouponRemoveConfirm = async (version: TabVersion, item: any) => {

  const index = couponImgData.value[version].activeIndex
  const idToRemove = item.id
  let res = false

  if(index === 0) {
    res = true
  } else if(index === 1) {
    const message = MEMBER_CODE.ALT_HCON_9115
    const result = await showConfirm({
      title: '상단 이미지 삭제',
      message: message,
      confirmText: '확인',
      cancelText: '취소'
    })
    
    if (result) {
      res = true
    }
  } 

  if(res) {
    removeImage(idToRemove)
  }
}

const removeThumbnail = (idToRemove: any) => {
  const index = thumbnails.findIndex(item => item?.id === idToRemove)

  if (index !== -1) {
    const nextIndex = index

    thumbnails.splice(index, 1)

    if (selectedItemId.value === idToRemove) {
      if (thumbnails.length > 0) {
        const newIndex = nextIndex >= thumbnails.length ? thumbnails.length - 1 : nextIndex
        const newSelectedItem = thumbnails[newIndex]
        selectThumbnail(newSelectedItem)
      } else {
        selectedItemId.value = null
        currentPreview.value.src = ''
        currentPreview.value.alt = ''
      }
    }
  }
}

// ######################################################################

onMounted(() => {
  getTapList()
})

// DTO 준비
import type { CommFileDto } from '~/types/common/backend-dto-types';
import type { TapMenuResDto, TopImageResDto } from '~/types/mypage/backend-dto-types';
const fetchBuilder  = useHconFetchBuilder() // 공통 조회 fetch

// 탭 목록 조회
const getTapList = async () => {
  const fetchBuilderResult = 
    fetchBuilder.get<AjaxResult<TapMenuResDto[]>>('/api/v1/mypage/coupon-top-image/tap-menu-list')
    .build()
    .execute()
    .then(res => {
      if(res.resultCode != '200') {
        showAlert({
          title: '알림',
          message: res.resultMessage,
          confirmText: '확인'
        })
      } else {
        const dataMap = res.data.map((item) => ({
          text: item.tapMenuNm,
          tapMenuCd: item.tapMenuCd,
          rcntImgUseYn: item.rcntImgUseYn
        })); 

        couponImgData.value.v3.items = dataMap

        const rcntImgUseYn = dataMap
          .filter(data => {
            return ((String(data.tapMenuCd) == '1001' || String(data.tapMenuCd) === '1002') && data.rcntImgUseYn === 'Y')
          })
          .sort((a, b) => Number(a.tapMenuCd) - Number(b.tapMenuCd))
          .at(0)

        // PIN주문서 작성 > 결제정보 입력 > 주문서 수정으로 다시 PIN주문서 작성 화면 들어왔을 때, 선택된 상단이미지 정보 세팅
        if (props.selectedTabIdx !== '' && props.selectedTopImg !== '') {
          handleTabClick('v3', Number(props.selectedTabIdx) - 1001);
        } else { // 그 외의 경우 데이터 세팅
          if(rcntImgUseYn !== undefined) {
            handleTabClick('v3', Number(rcntImgUseYn.tapMenuCd) - 1001) // 3번째 탭 클릭
          } else {
            handleTabClick('v3', 2) // 3번째 탭 클릭
          }
        }
      }
    })
}

// 이미지 목록 조회
const getImageList = async (param: string) => {
  const fetchBuilderResult = 
    fetchBuilder.post<AjaxResult<TopImageResDto[]>>('/api/v1/mypage/coupon-top-image/image-list')
    .body({
      hcCpnTopImgTypCd: param
    })
    .build()
    .execute()
    .then(res => {
      if(res.resultCode != '200') {
        showAlert({
          title: '알림',
          message: res.resultMessage,
          confirmText: '확인'
        })
      } else {
        thumbnails.length = 0;
        thumbnails.push(...res.data.map(item => ({
          id: Number(item.cpnTopImgSeq),
          src: cu.getFileFullUrl(item.cpnTopImgPath),
          alt: item.rmrk,
          bigSrc: cu.getFileFullUrl(item.cpnTopImgPath), 
          fileId: item.cpnTopImgPath,
          imgKey: item.cpnTopImgSeq + "_" + item.cpnTopImgUseSeq,
          useSeq: item.cpnTopImgUseSeq
        })))

        if(props.showBtnClose === true) {

          // 최근/My만 삭제 가능
          if(param === '1001' || param === '1002') {
            isDisabled.value = false
            btnClass.value = true
          } else {
            isDisabled.value = true
            btnClass.value = false
          }

          // 최초 로딩 시 0번 선택
          if(!isInitPage.value) {
            selectThumbnail(thumbnails[0])
            isInitPage.value = true
          }

        } else {
          isDisabled.value = false
          btnClass.value = false

          // PIN주문서 작성 > 결제정보 입력 > 주문서 수정으로 다시 PIN주문서 작성 화면 들어왔을 때, 선택된 상단이미지 정보 세팅
          if (props.selectedTabIdx !== '' && props.selectedTopImg !== '') {
            const selectedItem = thumbnails.filter(item => item?.id === Number(props.selectedTopImg));
            const index = thumbnails.findIndex(item => item?.id === Number(props.selectedTopImg));
            selectThumbnail(thumbnails[index]);
          }
        }
      }
    })
}

// 이미지 삭제
const removeImage = async (param: string) => {

  const tmpObj = thumbnails.filter(item => item?.id === Number(param))

  const fetchBuilderResult = 
    fetchBuilder.put<AjaxResult<Number>>('/api/v1/mypage/coupon-top-image/delete')
    .body({
      hcCpnTopImgTypCd: tapMenuCd,
      cpnTopImgSeq: param,
      cpnTopImgUseSeq: tmpObj[0]?.useSeq,
      topImage: {
                    id: tmpObj[0]?.fileId
                  , store: 'CONTENTS'
                  , name: ''
                  , contentType: ''
                  , size: 0
                  , status: 'MARKDELETE'
                  , statusDetail: ''
                }
    })
    .build()
    .execute()
    .then(res => {
      if(res.resultCode != '200') {
        showAlert({
          title: '알림',
          message: res.resultMessage,
          confirmText: '확인'
        })
      } else {
        removeThumbnail(param) // 삭제 후 이미지 리렌더링
      }
    })
}

// 이미지 등록
const uploadImage = async () => {

  // API 호출
  const fetchBuilderResult = 
    fetchBuilder.post<AjaxResult<CommFileDto>>('/api/v1/mypage/coupon-top-image/image-upload')
    .body({
        topImage: couponImage.value?.[0] ?? null
      })
    .progressMessage("잠시만 기다려주세요...")
    .build()
    .execute()
    .then((result) => {
      if(result.resultCode != '200') {
        showAlert({
          title: '알림',
          message: result.resultMessage,
          confirmText: '확인'
        })
      } else {
        // 정상인 경우 - DB처리
        if((result.data.file.id !== null && result.data.file.id.length > 0)
            && (result.data.file.name !== null && result.data.file.name.length > 0)) {
          createImage(result.data)
        } else {
          showAlert({
            title: '알림',
            message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9157),
            confirmText: '확인'
          })
        }
      }
    })
    .catch(err => {
      showAlert(err.resultMessage);
    })
}

// 이미지 등록
const createImage = async (req: CommFileDto) => {

  // API 호출
  const fetchBuilderResult = 
  fetchBuilder.post<AjaxResult<any>>('/api/v1/mypage/coupon-top-image/regist')
  .body({
      topImage: req.file
    })
  .progressMessage("잠시만 기다려주세요...")
  .build()
  .execute()
  .then((result) => {
    if(result.resultCode != '200') {
      showAlert({
        title: '알림',
        message: result.resultMessage,
        confirmText: '확인'
      })
    } else {
      // 저장 후 MY이동
      nextTick(() => {
        handleTabClick('v3', 1)
      })
    }
  })
  .catch(err => {
    showAlert(err.resultMessage);
  })
}

</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/mypage-hcon.scss" as *;

</style>